<template>
    <div id="derivedCurveMain">
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">General Information</div>
                </div>
                <br>
            </div>
            <div class="e-card-content">
                <!--ROW 1-->
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-textbox id='derivedCurveIdentifier' ref="derivedCurveIdentifier" name="derivedCurveIdentifier" width="60%" :enabled="isCreateMode" floatLabelType="Auto" v-model="data.derivedCurveIdentifier" placeholder="Derived Curve Identifier"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplStates' id="state" name="state" width="60%" v-model="data.stateId" :enabled="isCreateMode" :select='onStateChange' :dataSource='states' :fields="{text: 'stateName', value: 'stateId' }" placeholder="Country" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>

                <!--ROW 2-->
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplSourceCurveOne' id="sourceCurveOne" name="sourceCurveOne" width="60%" :enabled="isCreateMode" v-model="sourceCurveOne" :dataBound="onSourceCurveOneDataBound" :change="onSourceCurveOneChange" :dataSource='sourceCurvesPartial' :fields="{text: 'sourceIdentifierName', value: 'compositeKey' }" placeholder="Source Curve 1" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist> <!--:select='onStateChange'-->
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist id='priceArea' width="60%" ref='dplPriceArea' floatLabelType="Auto" name="priceArea" :enabled="false" v-model='prePricingAreaId' :dataSource='priceAreas' :fields="{text: 'name', value: 'id' }" placeholder="Price Area"></ejs-dropdownlist>
                    </div>
                </div>

                <!--ROW 3-->
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplSourceCurveTwo' id="sourceCurveTwo" name="sourceCurveTwo" :enabled="false" width="60%" v-model="sourceCurveTwo" :dataBound="onSourceCurveTwoDataBound" :dataSource='sourceCurvesAll' :change="onSurceCurveTwoChange" :fields="{text: 'sourceIdentifierName', value: 'compositeKey' }" placeholder="Source Curve 2" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="utility" name="utility" ref='dplUtility' width="60%" :enabled="isCreateMode" v-model="data.utilityTypeId" :dataSource='utilities' :select='onUtilityChange' :fields="{text: 'utilityTypeName', value: 'utilityTypeId' }" placeholder="Commodity" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>

                <!--ROW 4-->
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplSourceCurveThree' id="sourceCurveThree" name="sourceCurveThree" :enabled="false" width="60%" v-model="sourceCurveThree" :dataBound="onSourceCurveThreeDataBound" :dataSource='sourceCurvesAll' :change="onSurceCurveThreeChange" :fields="{text: 'sourceIdentifierName', value: 'compositeKey' }" placeholder="Source Curve 3" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id='product' width="60%" ref='dplProducts' floatLabelType="Auto" name="product" :enabled="isCreateMode" v-model='preProductId' :dataSource='products' :fields="{text: 'name', value: 'id' }" placeholder="Product" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>

                <!--ROW 5-->
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='outputUnit' ref="dplOutputUnit" name="outputUnit" width="60%" :enabled="false" floatLabelType="Auto" v-model="data.outputUnit" placeholder="Output Unit"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='description' ref="dplDescription" name="description" width="60%" :enabled="isCreateMode" floatLabelType="Auto" v-model="data.description" placeholder="Description"></ejs-textbox>
                    </div>
                </div>

                <!--ROW 6-->
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='createdDate' ref="createdDate" name="createdDate" width="60%" :enabled="false" floatLabelType="Auto" v-model="data.createdDate" placeholder="Created Date" :format="dateFormatOptions"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='createdBy' ref="createdBy" name="createdBy" width="60%" :enabled="false" floatLabelType="Auto" v-model="data.createdBy" placeholder="Created By"></ejs-textbox>
                    </div>
                </div>
            </div>
        </div>
        <br>

        <!--Formula Builder-->
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Formula Builder</div>
                </div>
            </div>
            <div class="e-card-content">
                <div class="row mb-2 align-items-center">
                    <div class="col-3">
                        <label>Source Curves</label>
                    </div>

                    <div class="col-9 d-flex align-items-center" style="gap: 10px;">

                        <ejs-button id="sourceOne"
                                    :content='buttonTextOne'
                                    :disabled="sourceOneButtonDisabled"
                                    cssClass="e-primary"
                                    v-on:click.native='btnSourceOneClick'>
                        </ejs-button>

                        <ejs-button id="sourceTwo"
                                    :content='buttonTextTwo'
                                    :disabled="sourceTwoButtonDisabled"
                                    cssClass="e-primary"
                                    v-on:click.native='btnSourceTwoClick'>
                        </ejs-button>

                        <ejs-button id="sourceThree"
                                    :content='buttonTextThree'
                                    :disabled="sourceThreeButtonDisabled"
                                    cssClass="e-primary"
                                    v-on:click.native='btnSourceThreeClick'>
                        </ejs-button>

                    </div>
                </div>
                <div class="row mb-2 align-items-center">
                    <div class="col-3">
                        <label>Monthly Parameters</label>
                    </div>
                    <div class="col-2">
                        <ejs-button id="parameterA" :disabled="parameterButtonsDisabled" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnParameterAClick'>A</ejs-button>
                        <ejs-button id="parameterB" :disabled="parameterButtonsDisabled" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnParameterBClick'>B</ejs-button>
                        <ejs-button id="parameterC" :disabled="parameterButtonsDisabled" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnParameterCClick'>C</ejs-button>
                        <ejs-button id="parameterD" :disabled="parameterButtonsDisabled" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnParameterDClick'>D</ejs-button>
                        <ejs-button id="parameterE" :disabled="parameterButtonsDisabled" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnParameterEClick'>E</ejs-button>
                    </div>
                </div>

                <div class="row mb-2 align-items-center">
                    <div class="col-3">
                        <label>Derived Curve Formula</label>
                    </div>
                </div>

                <div class="row mb-2 align-items-center">
                    <div class="col-3 form-group">
                        <ejs-textbox v-model="data.derivedCurveIdentifier"
                                     placeholder="Derived Curve Identifier"
                                     cssClass="text-right e-control"
                                     :readonly="true">
                        </ejs-textbox>
                    </div>
                    <div class="col-9 form-group">
                        <ejs-textbox id="formula"
                                     ref="tbFormula"
                                     v-model="data.formula"
                                     placeholder="Formula"
                                     cssClass="e-control"
                                     :enabled="isCreateMode">
                        </ejs-textbox>
                    </div>
                </div>
            </div>
        </div>
        <br>

        <!--Validity Periods-->
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Validity Periods</div>
                </div>
            </div>
            <template>
                <CRow>
                    <CCol>
                        <div class="e-card-content">
                            <div style="width:100%;" :class="{ 'grid-disabled': isCreateMode }">
                                <ejs-grid ref='periodGrid'
                                          id="periodGrid"
                                          :dataSource="periodData"
                                          :allowFiltering='true'
                                          :allowPaging='true'
                                          :allowResizing='true'
                                          :allowReordering='true'
                                          :allowSorting='true'
                                          :toolbar='toolbarPeriod'
                                          :toolbarClick='toolbarClick'
                                          :pageSettings='pageSettings'
                                          :filterSettings='filterOptions'
                                          :allowExcelExport='true'
                                          :actionComplete='periodGridActionComplete'
                                          :actionBegin='periodGridActionBegin'
                                          :actionFailure='actionFailure'
                                          :editSettings="editSettingsPeriodGrid"
                                          :query="gridQuery"
                                          :dataBound="periodGridDataBound"
                                          :rowSelected="rowSelected"
                                          :rowDeselected="rowDeselected">
                                    <e-columns>
                                        <e-column field='derivedCurveMonthlyId' headerText='Id' :isPrimaryKey='true' width=120 :visible='false' type="number"></e-column>
                                        <e-column field='derivedCurveId' headerText='derivedCurveId' width=120 :visible='false' type="number"></e-column>
                                        <e-column field='startDate' headerText='Start Date' type="date" width=150 editType="datepickeredit" :format="dateFormatOptions" :edit="dateParams" :validationRules="datesRules"></e-column>
                                        <e-column field='endDate' headerText='End Date' type="date" width=150 editType="datepickeredit" :format="dateFormatOptions" :edit="dateParams" :validationRules="datesRules"></e-column>
                                    </e-columns>
                                </ejs-grid>

                                <!--MONTHLY PARAMETERS DIALOG-->
                                <ejs-dialog ref="dialog" id="dialog" v-if="isLoaded" :visible="dialogVisible" header="Monthly Parameters Table" :isModal="true" :close="dialogClose" :showCloseIcon="true" width="50%">
                                        <ejs-grid ref='monthlyParametersGrid'
                                                  id='monthlyParametersGrid'
                                                  :dataSource="monthlyValues"
                                                  :pageSettings='pageSettings'
                                                  :allowExcelExport='true'
                                                  :actionComplete='actionCompleteMonthlyParameters'
                                                  :actionFailure='actionFailure'
                                                  :editSettings='editSettingsMonthlyParameters'
                                                  :toolbar='toolbarMonthlyParameters'
                                                  :dataBound="onDataBoundMonthlyParameters"
                                                  :actionBegin='actionBeginMonthlyParameters'
                                                  v-if="isLoaded">
                                        </ejs-grid>
                                        <!--FOOTER-->
                                        <div class="form-row">
                                            <div style="text-align: right; margin-top:20px;" class="form-group col-md-12">
                                                <ejs-button v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveMonthlyParametersClick'>Save</ejs-button>
                                                <ejs-button style="margin-right:10px" v-on:click.native='btnCancelClick'>Cancel</ejs-button>
                                            </div>
                                        </div>
                                </ejs-dialog>
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </template>
        </div>
        <br>

        <div class="e-card">
            <div class="e-card-content">
                <div class="clientButtons">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                        </div>
                        <div style="text-align: right; margin-top:20px;" class="form-group col-md-6">
                            <ejs-button v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClick'>Save</ejs-button>
                            <ejs-button v-on:click.native='btnBackClick'>Back</ejs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { DropDownListPlugin, MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, UploaderPlugin, TextBoxPlugin, FormValidator } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion'
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';
    import gridOptions from '../../common/gridOptions';
    import store from '../../store';
    import router from '../../router/index';
    import { Query } from '@syncfusion/ej2-data';
    import { ToastPlugin, Toast } from "@syncfusion/ej2-vue-notifications";
    import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";

    Vue.use(DialogPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);
    Vue.use(ToastPlugin);
    Vue.use(GridPlugin);

    let initDerivedCurveIdentifier, globalDerivedCurveId, DialogConfirmDeletePeriod = undefined;

    export default {
        name: 'DerivedCurveForm',
        created() {
            globalDerivedCurveId = this.$route.params.derivedCurveId;
            if (globalDerivedCurveId) {
                this.data.derivedCurveId = parseInt(globalDerivedCurveId);
            }
            if (!globalDerivedCurveId) {
                const btn = document.getElementById('UpdateParameters');
                if (btn) {
                    btn.classList.add('e-disabled');
                }
                return;
            }

            this.gridQuery = new Query().addParams("derivedCurveId", globalDerivedCurveId);
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '100',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });

            this.derivedCurveForms = new FormValidator("#derivedCurveMain", this.options);

            if (this.$route.params.derivedCurveId) {
                this.initializeForm(this.$route.params.derivedCurveId);
            }
        },
        data() {
            return {
                periodData: SyncHelper.getDataManager("derivedCurve/getPeriodGrid"),
                gridQuery: new Query(),
                isLoaded: false,
                isCreateMode: true,
                buttonTextOne: 'Source 1',
                sourceOneButtonDisabled: true,
                buttonTextTwo: 'Source 2',
                sourceTwoButtonDisabled: true,
                buttonTextThree: 'Source 3',
                sourceThreeButtonDisabled: true,
                parameterButtonsDisabled: false,
                data: {
                    formula: "",
                },
                sourceCurveOne: null,
                sourceCurveTwo: null,
                sourceCurveThree: null,
                derivedCurveForms: null,
                store: store,
                preStateId: null,
                preProductId: null,
                prePricingAreaId: null,
                products: null,
                priceAreas: null,
                utilityEnabled: false,
                toolbarPeriod: ['Add', 'Edit',
                    { text: 'Update Monthly Parameters', tooltipText: 'Update Monthly Parameters', prefixIcon: 'e-expand', id: 'UpdateParameters' },
                    { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeletePeriod' }],
                toolbarMonthlyParameters: ['Edit'],
                pageSettings: gridOptions.pageSettings,
                filterOptions: gridOptions.filterSettings,
                dialogVisible: false,
                editSettingsPeriodGrid: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.DerivedCurve.Update"],
                    allowAdding: store.state.permissions["Permissions.DerivedCurve.Create"],
                    allowDeleting: store.state.permissions["Permissions.DerivedCurve.Delete"],
                    allowEditOnDblClick: false,
                    mode: 'Dialog'
                },
                editSettingsMonthlyParameters: {
                    showConfirmDialog: false,
                    allowEditing: store.state.permissions["Permissions.DerivedCurve.Update"],
                    allowAdding: false,
                    allowDeleting: false,
                    mode: 'Normal'
                },
                monthlyValues: [],
                options: {
                    //Initialize the CustomPlacement.
                    customPlacement: function (inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group');
                        errorElement.style.width = '60%'
                        inputElement.appendChild(errorElement);
                    },
                    rules: {
                        'derivedCurveIdentifier': {
                            required: true
                        },
                        'sourceCurveOne': {
                            required: true
                        },
                        'state': {
                            required: true
                        },
                        'utility': {
                            required: true
                        },
                        'product': {
                            required: true
                        },
                        'priceArea': {
                            required: false
                        },
                        'formula': {
                            required: true
                        }
                    }
                },
                allowFiltering: true,
                canSave: this.$store.state.permissions["Permissions.DerivedCurve.Create"],
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', min: new Date(), params: { min: new Date() } },
                enableToolbar: true,
                gridAlreadyFormatted: false,
                initialRefresh: true,
                dateParams: {
                    params: {
                        min: new Date(new Date().setHours(0, 0, 0, 0))
                    }
                },
                isExpired: false,
                isActive: false,
                isFuture: false,
                datesRules: { minlength: [(args) => { return this.dateInPast(args) }, 'Date cannot be in past'] },
            }
        },
        methods: {
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            initializeForm(derivedCurveId) {
                apis.protectedApi(`derivedCurve/${derivedCurveId}`, { isDateFix: true })
                    .then(response => {
                        this.data = response.data.data;
                        this.isCreateMode = false;

                        const derivedSourceCurves = this.data.derivedSourceCurves;

                        this.populateSourceCurves(this.data.derivedSourceCurves);
                        this.populateProduct(this.data.utilityTypeId, false);
                        this.populatePriceAreas(this.data.stateId, this.data.productId, false);
                        this.disableFormFields();

                        this.formatLastUpdatedDate();

                        const btn = document.getElementById('UpdateParameters');
                        if (btn) {
                            btn.classList.remove('e-disabled');
                        }

                        initDerivedCurveIdentifier = this.data.derivedCurveIdentifier;

                    }).catch(e => {
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            populateSourceCurves: function (derivedSourceCurves) {
                this.sourceCurveOne = derivedSourceCurves.find(s => s.sourceOrder === 1)?.compositeKey || null;
                this.sourceCurveTwo = derivedSourceCurves.find(s => s.sourceOrder === 2)?.compositeKey || null;
                this.sourceCurveThree = derivedSourceCurves.find(s => s.sourceOrder === 3)?.compositeKey || null;
            },
            actionCompleteMonthlyParameters: function (args) {
                if (args.requestType === 'save') {
                    const index = this.monthlyValues.findIndex(item => item.Month === args.data.Month);

                    if (index !== -1) {
                        this.$set(this.monthlyValues, index, { ...args.data });
                    }
                    args.cancel = true;
                }
            },
            onUtilityChange: function (e) {
                this.populateProduct(e.itemData.utilityTypeId, true);
            },
            onStateChange: function (e) {
                if (e.isInteracted == true) {
                    this.populatePriceAreas(e.itemData.stateId, this.prePricingAreaId, true);
                }
            },
            btnSaveClick: function (e) {
                e.preventDefault();
                let formStatus = this.derivedCurveForms.validate();
                if (formStatus) {
                    showSpinner(document.getElementById('mainSpinner'));
                    if (globalDerivedCurveId) {
                        if (initDerivedCurveIdentifier === this.data.derivedCurveIdentifier) {
                            let message = {
                                title: 'Success!',
                                content: 'Derived Curve is updated successfully',
                                cssClass: 'e-toast-success'
                            };
                            this.$root.$emit('showToast', message);
                            hideSpinner(document.getElementById('mainSpinner'));
                        }
                    }
                    else {
                        this.createDerivedCurve();
                    }
                }
            },
            createDerivedCurve: function () {
                this.data.derivedSourceCurves = [];

                this.data.derivedSourceCurves.push(this.data.sourceCurveOne);
                if (this.data.sourceCurveTwo)
                    this.data.derivedSourceCurves.push(this.data.sourceCurveTwo);
                if (this.data.sourceCurveThree)
                    this.data.derivedSourceCurves.push(this.data.sourceCurveThree);

                const isValidFormula = this.validateFormula();

                if (!isValidFormula)
                    return;

                this.data.productId = this.preProductId;
                this.data.pricingAreaId = this.prePricingAreaId;

                apis.protectedApi.post(`derivedCurve`, this.data)
                    .then(response => {
                        if (response.data.error) {
                            hideSpinner(document.getElementById('mainSpinner'));
                            this.showErrorDialog(response.data.error);
                        }
                        else {
                            let message = {
                                title: 'Success!',
                                content: 'Derived Curve is created successfully',
                                cssClass: 'e-toast-success'
                            };
                            this.$root.$emit('showToast', message);
                            globalDerivedCurveId = response.data.derivedCurveId;
                            this.isCreateMode = false;
                            this.$router.push({
                                name: "Derived Curve Form",
                                params: { derivedCurveId: response.data.derivedCurveId }
                            }).catch(err => {
                                // Ignore the vuex err regarding  navigating to the page they are already on.
                                if (err.name != "NavigationDuplicated") {
                                    // But print any other errors to the console
                                    console.error(err);
                                }
                            });
                            this.gridQuery = new Query().addParams("derivedCurveId", globalDerivedCurveId);
                            this.$refs.periodGrid.refresh();
                            hideSpinner(document.getElementById('mainSpinner'));
                        }
                    }).catch(e => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    });
            },
            validateFormula: function () {
                const validSourceOptions = this.data.derivedSourceCurves.map(item => item.sourceIdentifierName);
                const parameterOptions = ['A', 'B', 'C', 'D', 'E'];
                const allValidOptions = [...validSourceOptions, ...parameterOptions];

                const formula = this.data.formula;
                const regex = /\[([^\]]+)\]/g;
                let match;
                let foundTokens = [];

                while ((match = regex.exec(formula)) !== null) {
                    foundTokens.push(match[1]);
                }

                const invalidTokens = foundTokens.filter(token => !allValidOptions.includes(token));

                if (invalidTokens.length > 0) {
                    this.showErrorDialog("The formula contains invalid parameters. Please ensure all values in square brackets match the available options.");
                    hideSpinner(document.getElementById('mainSpinner'));
                    return false;
                }

                const implicitMultiplicationRegex = /(\]\s*\[)|(\d\s*\[)|(\]\s*\d)/;

                if (implicitMultiplicationRegex.test(formula)) {
                    this.showErrorDialog("Missing operator detected in formula. Use explicit operators between all fields and values.");
                    hideSpinner(document.getElementById('mainSpinner'));
                    return false;
                }

                const openCount = (formula.match(/\[/g) || []).length;
                const closeCount = (formula.match(/\]/g) || []).length;

                if (openCount !== closeCount) {
                    this.showErrorDialog("Mismatched brackets: Each '[' requires a matching '].");
                    hideSpinner(document.getElementById('mainSpinner'));
                    return false;
                }

                return true;
            },
            btnBackClick: function (e) {
                router.push({ name: "Product Specifications" });
            },
            populateProduct: function (utilityId, isChangeEvent) {
                this.preProductId = null;

                apis.protectedApi(`utils/tradableProducts?utilityTypeId=${utilityId}`)
                    .then(response => {
                        this.products = response.data;
                        this.$nextTick(() => {
                            this.preProductId = isChangeEvent ? null : this.data.productId;
                        });
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            },
            populatePriceAreas: function (stateId, productId, isChangeEvent) {
                this.prePricingAreaId = null;
                apis.protectedApi(`utils/priceAreasWithoutStateName?stateId=${stateId}`)
                    .then(response => {
                        this.priceAreas = response.data;
                        if (this.priceAreas.length > 0) {
                            if (isChangeEvent) {
                                this.$refs.dplPriceArea.ej2Instances.enabled = true;
                                this.derivedCurveForms.rules.priceArea.required = true;
                            }
                            const arrayFields = ["priceArea"]
                            setTimeout(function () {
                                arrayFields.forEach(function (item) {
                                    let inputElement = document.getElementById(item);
                                    if (inputElement) {
                                        let parentDiv = inputElement.closest('.input-group');
                                        if (parentDiv) {
                                            parentDiv.classList.add('required-input');
                                        }
                                    }
                                });
                            }, 300);
                        }
                        else {
                            this.$refs.dplPriceArea.ej2Instances.enabled = false;
                            this.derivedCurveForms.rules.priceArea.required = false;
                        }
                        this.$nextTick(() => {
                            this.prePricingAreaId = isChangeEvent ? null : this.data.pricingAreaId;
                        });

                        if (!isChangeEvent)
                            this.$refs.dplPriceArea.ej2Instances.enabled = false;

                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            },
            btnParameterAClick() {
                this.$refs.tbFormula.ej2Instances.value += `[A]`;
            },
            btnParameterBClick() {
                this.$refs.tbFormula.ej2Instances.value += `[B]`;
            },
            btnParameterCClick() {
                this.$refs.tbFormula.ej2Instances.value += `[C]`;
            },
            btnParameterDClick() {
                this.$refs.tbFormula.ej2Instances.value += `[D]`;
            },
            btnParameterEClick() {
                this.$refs.tbFormula.ej2Instances.value += `[E]`;
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            toolbarClick: function (args) {

                if (args.item.id === 'UpdateParameters') {
                    args.cancel = true;
                    this.$refs.periodGrid.closeEdit();
                    this.getMonthlyParametersGrid(args);
                }

                else if (args.item.id === 'DeletePeriod') {
                    let selectedPeriod = this.$refs.periodGrid.getSelectedRecords();
                    if (selectedPeriod.length > 0) {
                        DialogConfirmDeletePeriod = DialogUtility.confirm({
                            title: 'Confirm Delete',
                            content: "Are you sure you want to delete this record? This will also delete associated monthly parameters.",
                            position: { X: 700, Y: 200 },
                            okButton: { text: 'OK', click: this.confirmDeletePeriod },
                            cancelButton: { text: 'Cancel', click: this.cancelDeletePeriod },
                            open: () => {
                                this.$refs.focusElement.focus();
                            },
                            showCloseIcon: true,
                            closeOnEscape: true,
                        });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a record first.",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
            },
            confirmDeletePeriod: function () {
                this.$refs.periodGrid.showSpinner();
                let selectedPeriod = this.$refs.periodGrid.getSelectedRecords();
                let derivedCurvePeriodId = selectedPeriod[0].derivedCurvePeriodId;

                apis.protectedApi.delete(`derivedCurve/deletePeriod/${derivedCurvePeriodId}`)
                    .then(response => {
                        let message = {
                            title: 'Success!',
                            content: 'Derived Curve Period is deleted successfully!',
                            cssClass: 'e-toast-success'
                        };

                        this.$root.$emit('showToast', message);
                        this.$refs.periodGrid.hideSpinner();
                        this.$refs.periodGrid.refresh();
                    }).catch(e => {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: e.response.data.message,
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                        this.$refs.periodGrid.hideSpinner();
                    });

                DialogConfirmDeletePeriod.hide();

            },

            cancelDeletePeriod: function () {
                DialogConfirmDeletePeriod.hide();
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            dialogClose() {
                this.dialogVisible = false;

                // We need it because of the Edit button - it keeps getting enabled even though it shouldn't be
                const gridInstance = this.$refs.periodGrid.ej2Instances;
                const editBtn = `${gridInstance.element.id}_edit`;

                gridInstance.toolbarModule.enableItems(
                    [editBtn],
                    (this.data.isActive || this.data.isFuture) && this.hasPermission("Permissions.DerivedCurve.Update")
                );

                gridInstance.toolbarModule.enableItems(['DeletePeriod'], this.data.isFuture && this.hasPermission("Permissions.DerivedCurve.Delete"));
            },
            btnCancelClick() {
                this.dialogVisible = false;
            },
            onSourceCurveOneChange(e) {
                if (e.itemData) {
                    this.buttonTextOne = e.itemData.sourceIdentifierName;
                    this.sourceOneButtonDisabled = false;

                    this.data.sourceCurveOne = e.itemData;
                    this.data.sourceCurveOne.sourceOrder = 1;
                    this.$refs.dplSourceCurveTwo.ej2Instances.enabled = true;
                }
                else {
                    this.buttonTextOne = 'Source 1';
                    this.sourceOneButtonDisabled = true;
                    this.$refs.dplSourceCurveTwo.ej2Instances.enabled = false;
                }

                if (this.$refs.tbFormula.ej2Instances.value !== "")
                    this.data.formula = "";
            },
            onSourceCurveOneSelect(e) {
                if (e.itemData) {
                    this.buttonTextOne = e.itemData.sourceIdentifierName;
                    this.sourceOneButtonDisabled = false;

                    if (this.$refs.tbFormula.ej2Instances.value !== "")
                        this.data.formula = "";

                    this.data.sourceCurveOne = e.itemData;
                    this.data.sourceCurveOne.sourceOrder = 1;
                }
                else {
                    this.buttonTextOne = 'Source 1';
                    this.sourceOneButtonDisabled = true;
                }
            },
            onSurceCurveTwoChange(e) {
                if (e.itemData) {
                    this.buttonTextTwo = e.itemData.sourceIdentifierName;
                    this.sourceTwoButtonDisabled = false;

                    if (this.$refs.tbFormula.ej2Instances.value !== "")
                        this.data.formula = "";

                    this.data.sourceCurveTwo = e.itemData;
                    this.data.sourceCurveTwo.sourceOrder = 2;
                    this.$refs.dplSourceCurveThree.ej2Instances.enabled = true;
                }
                else {
                    this.buttonTextTwo = 'Source 2';
                    this.sourceTwoButtonDisabled = true;
                    this.$refs.dplSourceCurveThree.ej2Instances.enabled = false;
                    this.data.sourceCurveTwo = null;
                }
            },
            onSurceCurveThreeChange(e) {
                if (e.itemData) {
                    this.buttonTextThree = e.itemData.sourceIdentifierName;
                    this.sourceThreeButtonDisabled = false;

                    if (this.$refs.tbFormula.ej2Instances.value !== "")
                        this.data.formula = "";

                    this.data.sourceCurveThree = e.itemData;
                    this.data.sourceCurveThree.sourceOrder = 3;
                }
                else {
                    this.buttonTextThree = 'Source 3';
                    this.sourceThreeButtonDisabled = true;
                    this.data.sourceCurveThree = null;
                }
            },
            onSourceCurveOneDataBound() {
                if (this.$refs.dplSourceCurveOne.ej2Instances.itemData && this.$route.params.derivedCurveId) {
                    this.buttonTextOne = this.$refs.dplSourceCurveOne.ej2Instances.itemData.sourceIdentifierName;
                    this.sourceOneButtonDisabled = true;
                }
            },
            onSourceCurveTwoDataBound() {
                if (this.$refs.dplSourceCurveTwo.ej2Instances.itemData && this.$route.params.derivedCurveId) {
                    this.buttonTextTwo = this.$refs.dplSourceCurveTwo.ej2Instances.itemData.sourceIdentifierName;
                    this.sourceTwoButtonDisabled = true;
                }
            },
            onSourceCurveThreeDataBound() {
                if (this.$refs.dplSourceCurveThree.ej2Instances.itemData && this.$route.params.derivedCurveId) {
                    this.buttonTextThree = this.$refs.dplSourceCurveThree.ej2Instances.itemData.sourceIdentifierName;
                    this.sourceThreeButtonDisabled = true;
                }
            },
            btnSourceOneClick: function (e) {
                if (this.$refs.dplSourceCurveOne.ej2Instances.itemData.sourceCurveName); {
                    this.$refs.tbFormula.ej2Instances.value += `[${this.$refs.dplSourceCurveOne.ej2Instances.itemData.sourceIdentifierName}]`;
                }
            },
            btnSourceTwoClick() {
                if (this.$refs.dplSourceCurveTwo.ej2Instances.itemData.sourceCurveName); {
                    this.$refs.tbFormula.ej2Instances.value += `[${this.$refs.dplSourceCurveTwo.ej2Instances.itemData.sourceIdentifierName}]`;
                }
            },
            btnSourceThreeClick() {
                if (this.$refs.dplSourceCurveThree.ej2Instances.itemData.sourceCurveName); {
                    this.$refs.tbFormula.ej2Instances.value += `[${this.$refs.dplSourceCurveThree.ej2Instances.itemData.sourceIdentifierName}]`;
                }
            },
            periodGridActionBegin(args) {
                if (args.requestType === 'save') {
                    const row = args.data;
                    if (args.action === 'add') {
                        args.cancel = true;
                        row.derivedCurveId = globalDerivedCurveId;

                        if (!this.validatePeriodDates(row)) {
                            return;
                        }

                        apis.protectedApi.post(`derivedCurve/postPeriods`, row, { isDateFix: true })
                            .then(response => {
                                this.$refs.periodGrid.ej2Instances.closeEdit();
                                let message = {
                                    title: 'Success!',
                                    content: 'Derived Curve Period is created successfully',
                                    cssClass: 'e-toast-success'
                                };
                                this.$refs.periodGrid.refresh();
                                this.$refs.periodGrid.hideSpinner();
                                this.$root.$emit('showToast', message);
                            }).catch(e => {
                                if (e.response) {
                                    this.$refs.periodGrid.ej2Instances.closeEdit();
                                    this.showErrorDialog(e.response.data.message);

                                }
                            });
                    }
                    else if (args.action === 'edit') {
                        args.cancel = true;
                        row.derivedCurveId = globalDerivedCurveId;

                        if (!this.validatePeriodDates(row)) {
                            return;
                        }

                        apis.protectedApi.put(`derivedCurve/putPeriods`, row, { isDateFix: true })
                            .then(response => {
                                this.$refs.periodGrid.ej2Instances.closeEdit();
                                let message = {
                                    title: 'Success!',
                                    content: 'Derived Curve Period is updated successfully',
                                    cssClass: 'e-toast-success'
                                };
                                this.$refs.periodGrid.refresh();
                                this.$refs.periodGrid.hideSpinner();
                                this.$root.$emit('showToast', message);
                            }).catch(e => {
                                if (e.response) {
                                    this.$refs.periodGrid.ej2Instances.closeEdit();
                                    this.showErrorDialog(e.response.data.message);

                                }
                            });
                    }
                }
            },
            getMonthlyParametersGrid: function (args) {
                this.monthlyValues = [];
                const derivedCurvePeriod = this.$refs.periodGrid.getSelectedRecords();

                if (derivedCurvePeriod.length > 0) {
                    const derivedCurvePeriodId = this.$refs.periodGrid.getSelectedRecords()[0].derivedCurvePeriodId;
                    apis.protectedApi(`derivedCurve/getMonthlyParametersGrid?derivedCurvePeriodId=${derivedCurvePeriodId}`)
                        .then(response => {
                            this.monthlyValues = response.data;
                            this.isLoaded = true;
                            this.dialogVisible = true;
                            this.initialRefresh = true;
                        }).catch(e => {
                            if (e.response)
                                this.showErrorDialog(e.response.data.message);
                        });
                }
                else {
                    DialogUtility.alert({
                        title: 'Alert Dialog',
                        content: "Please, choose a derived curve period first.",
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                }
            },
            btnSaveMonthlyParametersClick: function (e) {
                this.$refs.monthlyParametersGrid.endEdit();

                const selectedPeriod = this.$refs.periodGrid.getSelectedRecords();

                if (!selectedPeriod.length)
                    return;

                e.preventDefault();
                showSpinner(document.getElementById('mainSpinner'));
                const dialogElement = this.$refs.dialog.ej2Instances.element;
                createSpinner({ target: dialogElement });
                showSpinner(dialogElement);
                if (globalDerivedCurveId) {
                    apis.protectedApi.post(`derivedCurve/monthlyParameters?derivedCurvePeriodId=${selectedPeriod[0].derivedCurvePeriodId}`, this.monthlyValues)
                        .then(response => {
                            this.dialogVisible = false;
                            let message = {
                                title: 'Success!',
                                content: 'Derived Curve Monthly Parameters are updated successfully',
                                cssClass: 'e-toast-success'
                            };
                            this.initialRefresh = true;
                            hideSpinner(dialogElement);
                            hideSpinner(document.getElementById('mainSpinner'));
                            this.$root.$emit('showToast', message);
                        }).catch(e => {
                            hideSpinner(document.getElementById('mainSpinner'));
                            hideSpinner(dialogElement);
                            if (e.response) {
                                this.showErrorDialog(e.response.data.message);

                            }
                        });
                }
            },
            actionBeginMonthlyParameters(args) {
                if (args.requestType === 'beginEdit') {
                    const column = this.$refs.monthlyParametersGrid.ej2Instances.getColumnByField("MonthName");
                    column.allowEditing = false;
                }
            },
            onDataBoundMonthlyParameters() {
                let grid = this.$refs.monthlyParametersGrid.ej2Instances;

                grid.toolbarModule.enableItems(['Edit'], this.hasPermission("Permissions.DerivedCurve.Update"));

                let monthColumn = grid.getColumnByField("Month");
                if (monthColumn) {
                    monthColumn.isPrimaryKey = true;
                }
                grid.getColumnByField("MonthName").headerText = "Month";
                grid.refreshHeader();

                const gridElement = this.$refs.monthlyParametersGrid.$el;
                if (this.data.isActive || this.data.isExpired)
                    gridElement.classList.add('grid-is-locked');
                else
                    gridElement.classList.remove('grid-is-locked');

                if (this.initialRefresh) {

                    for (var i = 0; i < grid.columns.length; i++) {
                        if (grid.columns[i].field.endsWith('_ID') || grid.columns[i].field === 'Month')
                            grid.hideColumns(grid.columns[i].field);
                        else if (grid.columns[i].field && !grid.columns[i].field.endsWith('_ID') && grid.columns[i].field !== 'Month') {
                            grid.columns[i].editType = 'numericEdit';
                            grid.columns[i].format = 'n5';
                            grid.columns[i].edit = { params: { decimals: 5, format: 'n5' } };
                        }
                    }

                    this.$refs.monthlyParametersGrid.ej2Instances.refreshColumns();
                    this.$refs.monthlyParametersGrid.refresh()
                    this.initialRefresh = false;
                }
            },
            periodGridDataBound(args) {
                const grid = this.$refs.periodGrid.ej2Instances;
                const hasRecords = grid.currentViewData.length > 0;
                //grid.toolbarModule.enableItems(['UpdateParameters', 'DeletePeriod'], hasRecords);

                grid.toolbarModule.enableItems(['Add'], this.hasPermission("Permissions.DerivedCurve.Create"));
                grid.toolbarModule.enableItems(['Edit'], this.hasPermission("Permissions.DerivedCurve.Update"));
                grid.toolbarModule.enableItems(['UpdateParameters'], hasRecords && this.hasPermission("Permissions.DerivedCurve.View"));
                grid.toolbarModule.enableItems(['DeletePeriod'], hasRecords && this.hasPermission("Permissions.DerivedCurve.Delete"));
            },
            formatLastUpdatedDate: function () {
                const tempDate = new Date(this.data.createdDate);

                const d = new Date(Date.UTC(
                    tempDate.getFullYear(),
                    tempDate.getMonth(),
                    tempDate.getDate(),
                    tempDate.getHours(),
                    tempDate.getMinutes(),
                    tempDate.getSeconds()
                ));

                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                const hours = String(d.getHours()).padStart(2, '0');
                const minutes = String(d.getMinutes()).padStart(2, '0');

                const zone = new Intl.DateTimeFormat('en-GB', { timeZoneName: 'short' })
                    .formatToParts(d)
                    .find(p => p.type === 'timeZoneName').value;

                this.data.createdDate = `${day}/${month}/${year} ${hours}:${minutes} ${zone}`;
            },
            disableFormFields: function () {
                this.sourceOneButtonDisabled = true;
                this.sourceTwoButtonDisabled = true;
                this.sourceThreeButtonDisabled = true;
                this.parameterButtonsDisabled = true;
                this.$refs.dplSourceCurveTwo.ej2Instances.enabled = false;
                this.$refs.dplSourceCurveThree.ej2Instances.enabled = false;
            },
            rowSelected(args) {
                const toolbarEle = this.$refs.periodGrid?.$el?.querySelector('.e-toolbar');
                this.isLockedPeriod(args.data.startDate, args.data.endDate);
                const gridElement = this.$refs.periodGrid.ej2Instances.element;
                const toolbarElee = gridElement.querySelector('.e-toolbar');

                const editBtnn = toolbarEle.querySelector('.e-edit');
                const deleteBtn = toolbarEle.querySelector('.e-delete');
                const updateParamsBtn = toolbarEle.querySelector('#updateParams');
                const gridInstance = this.$refs.periodGrid.ej2Instances;
                const gridId = gridInstance.element.id;
                const editBtn = `${gridInstance.element.id}_edit`;

                gridInstance.toolbarModule.enableItems(
                    [editBtn],
                    (this.data.isActive || this.data.isFuture) && this.hasPermission("Permissions.DerivedCurve.Update")
                );

                gridInstance.toolbarModule.enableItems(['DeletePeriod'], this.data.isFuture && this.hasPermission("Permissions.DerivedCurve.Delete"));
            },
            rowDeselected() {
                const gridInstance = this.$refs.periodGrid.ej2Instances;
                const gridId = gridInstance.element.id;
                const editBtn = `${gridInstance.element.id}_edit`;

                gridInstance.toolbarModule.enableItems(
                    [editBtn, 'DeletePeriod'],
                    this.hasPermission("Permissions.DerivedCurve.Delete")
                );
            },
            isLockedPeriod(startDate, endDate) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const start = new Date(startDate);
                start.setHours(0, 0, 0, 0);

                const end = endDate ? new Date(endDate) : null;
                if (end) end.setHours(0, 0, 0, 0);

                const isExpired = end !== null && end < today;
                const isActive = start < today && (end === null || end >= today);
                const isFuture = start >= today;

                this.data.isExpired = isExpired;
                this.data.isActive = isActive;
                this.data.isFuture = isFuture;
            },
            dateInPast: function (args) {
                if (!args.value) return true;
                if (args.element.defaultValue === args.value) return true;

                let inputDate;

                if (args.value instanceof Date) {
                    inputDate = new Date(args.value);
                } else {
                    const parts = args.value.split('/');
                    if (parts.length === 3) {
                        inputDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                    } else {
                        inputDate = new Date(args.value);
                    }
                }

                inputDate.setHours(0, 0, 0, 0);
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                return isNaN(inputDate.getTime()) ? true : inputDate >= today;
            },
            periodGridActionComplete(args) {
                if (args.requestType === 'beginEdit') {
                    const fieldName = 'startDate';
                    const inputElement = args.form.querySelector(`[name="${fieldName}"]`);
                    if (inputElement && this.data.isActive) {
                        const parentDiv = inputElement.closest('.e-error');

                        if (args.rowData[fieldName]) {
                            const instance = inputElement.ej2_instances[0];
                            if (instance) {
                                instance.enabled = false;
                            }

                            if (parentDiv) {
                                parentDiv.classList.remove('e-error');
                            }
                        }
                    }
                }
            },
            validatePeriodDates(row) {
                if (!row.startDate) {
                    gridOptions.errorAlert("Start date must be a valid date.");
                    return false;
                }

                const endDate = row.endDate ? new Date(row.endDate).getTime() : Infinity;
                if (new Date(row.startDate).getTime() > endDate) {
                    gridOptions.errorAlert("End Date must be greater than Start Date.");
                    return false;
                }

                return true;
            },
            hasPermission(permission) {
                return !!this.$store.state.permissions[permission];
            },
        },
        updated() {
        },
        beforeRouteUpdate(to, from, next) {
            next();
            if (to.params.derivedCurveId) {
                this.initializeForm(to.params.derivedCurveId);
            }
        },
        computed: {
            states() {
                return SyncHelper.getDataManager("utils/states");
            },
            utilities() {
                return SyncHelper.getDataManager("utils/utilities");
            },
            sourceCurvesPartial() {
                return SyncHelper.getDataManager("utils/sourceCurves?fullSet=false");
            },
            sourceCurvesAll() {
                return SyncHelper.getDataManager("utils/sourceCurves?fullSet=true");
            },
            parameterNames() {
                return SyncHelper.getDataManager("utils/parameterNames");
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        }
    }
</script>

<style>
    .loading {
        position: fixed;
        z-index: 1;
        /*height: 100%;
        width: 100%;*/
        background-color: lightgray;
        opacity: 0.6;
        overflow: hidden;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .box-auto {
        padding-right: 3.5rem !important;
    }

    .e-input-group {
        height: 30px;
    }

    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }

    .grid-disabled {
        pointer-events: none;
        opacity: 0.6;
        cursor: not-allowed;
    }
    
    .grid-is-locked {
        pointer-events: none !important;
        opacity: 0.7;
    }
</style>